import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";

function CupsCliente() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [ciediez, setCiediez] = useState([]);
    const [ciediezCliente, setCiediezCliente] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');
    let userdata = [];
    let clientData = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [terminoBusquedaSeleccionados, setTerminoBusquedaSeleccionados] = useState('');

    const [toastMsg, setToastMsg] = useState('');

    const cols = [
        { name:'Código', selector:row => row.CODIGO_CUPS, sortable:true },
        { name:'Nombre', selector:row => row.NOMBRE_CUPS, sortable:true },
        { name:'Acción', cell:row => getBotones(row), minWidth: '10%' }
    ];

    const cols2 = [
        { name:'Código', selector:row => row.codigo_cups, sortable:true },
        { name:'Nombre', selector:row => row.nombre_cups, sortable:true },
        { name:'Acción', cell:row => getBotonesCodigosCliente(row), minWidth: '10%' }
    ]

    const getBotones = (item) => {
        
        return (
            <>
            <Link to={'#'} onClick={() => agregarCodigo(item.id, item.CODIGO_CUPS, item.NOMBRE_CUPS)} className="btn btn-primary btn-sm">Agregar&nbsp;<i className="fas fa-plus"></i></Link>
            </>
        )
    }

    const getBotonesCodigosCliente = (item) => {
        
        return (
            <>
            <Link to={'#'} onClick={() => eliminarCodigo(item.id, item.codigo_cups, item.nombre_cups)} className="btn btn-primary btn-sm"><i className="fas fa-trash-alt"></i>&nbsp;Eliminar</Link>
            </>
        )
    }

    function agregarCodigo(id,codigo,nombre) {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            id_client: client.client_id,
            codigo_cups: codigo,
            nombre_cups: nombre
        }

        axios.post('cups-cliente',config)
            .then(response => {
                if (response.status===200) {
                    cargarCupsCliente();
                    setToastMsg('El Código '+codigo+' - \''+nombre+'\'Ha Sido Guardado Con Éxito');
                }
            })
            .catch(error => console.log(error))
    }


    function eliminarCodigo(id,codigo,nombre) {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id_client: client.client_id,
                id: id
            }
        }   

        axios.delete('cups-cliente',config)
            .then(response => {
                if (response.status===200) {
                    cargarCupsCliente();
                    setToastMsg('El Código '+codigo+' - \''+nombre+'\'Ha Sido Eliminado Con Éxito');
                }
            })
            .catch(error => console.log(error))
    }



    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('cups-todo',config)
            .then(response => {
                if (response.status===200) {
                    setCiediez(response.data);
                }
            })
            .catch(error => console.log(error))

        
        cargarCupsCliente();

    },[]);



    function cargarCupsCliente() {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/cups-cliente?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setCiediezCliente(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }



    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda
            }
        }

        axios.get('/cups-todo',config)
            .then(response => {
                setCiediez(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    },[terminoBusqueda]);


    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                termino: terminoBusquedaSeleccionados
            }
        }

        axios.get('/cups-cliente',config)
            .then(response => {
                setCiediezCliente(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    },[terminoBusquedaSeleccionados]);



    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-rips">Administrar RIPS</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Códigos CUPS</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    {/*<h1 className="m-0">Códigos CIE-10</h1>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                        
                        <div className="row">
                            
                            <div className="col-md-6">

                                <h3>Códigos CUPS</h3>
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Buscar Por Nombre o Código</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>

                                <DataTable
                                columns={cols}
                                data={ciediez}
                                pagination
                                id={'ciediez_todo'}
                                />

                            </div>

                            <div className="col-md-6">

                                <h3>Códigos Seleccionados</h3>
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Buscar Por Nombre o Código</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusquedaSeleccionados(e.target.value)} />
                                </div>
                                
                                <DataTable
                                columns={cols2}
                                data={ciediezCliente}
                                pagination
                                id={'ciediez'}
                                />

                            </div>

                        </div>

                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default CupsCliente;